import React, {Component} from "react";
import {Input} from "reactstrap";

class TimeTrackingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      formTitle: ''
    };
  }

  componentDidMount() {
    this.setState({
      categories: this.initialCategories
    })
  }

  addCategoryClick() {
   this.setState({
     categories: [...this.categories, '']
   })
  }

  handleCategoryChange(i, e) {
    const { value } = e.target;

    this.setState({
      categories: this.categories.map((c, j) => {
        if(i === j) {
          return value
        }
        return c
      })
    })
  }

  removeCategoryClick(i) {
    this.setState({
      categories: this.categories.filter((c, j) => j !== i)
    })
  }

  handleFormTitleChange(e) {
    this.setState({
      formTitle: e.target.value
    });
  }

  get formTitle() {
    if (this.props.initialValues && this.props.initialValues.form_title && this.state.formTitle == '') {
      return this.props.initialValues.form_title
    }

    return this.state.formTitle;
  }

  get initialCategories() {
    return this.props.initialValues && this.props.initialValues.categories ? this.props.initialValues.categories : [];
  }

  get categories() {
    return this.state.categories;
  }

  handleSubmit() {
    this.props.onSave({
      categories: this.categories,
      form_title: this.formTitle,
    });
  }

  render() {
    return (
      <div className="time-tracking-form call-log-field">
        <div className="form-title">
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Form Title
              </label>
            </div>

            <div className="input-conatiner">
              <Input
                name="form-title"
                onChange={this.handleFormTitleChange.bind(this)}
                placeholder="Form Title"
                type="text"
                value={this.formTitle}
              />
            </div>
          </div>
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Categories
              </label>
            </div>

            {this.categories.map((category, i) => (
              <div key={`${i}`} className="select-options-container">
                <Input
                  name="value"
                  onChange={this.handleCategoryChange.bind(this, i)}
                  placeholder="Value"
                  type="text"
                  value={category || ''}
                />

                <div className="delete-container">
                  <button className="button danger small" type="button" onClick={this.removeCategoryClick.bind(this, i)} >
                    <i className="fa fa-trash"/>
                  </button>
                </div>
              </div>
            ))
            }

            <button className="button primary small" onClick={() => this.addCategoryClick()}>
              Add Category
            </button>
          </div>
        </div>

        <button className="button primary large log-field-save" type="button" onClick={this.handleSubmit.bind(this)} >
          Save
        </button>
      </div>
    )
  }
}

export default TimeTrackingForm
